import { Outlet } from "react-router-dom";
import Header from "./Header";

export default function Layout() {
    return (
        <div className="h-screen relative flex flex-col">
            <Header />
            <Outlet />
        </div>
    );
}